import OrderHistoryDetailTrackingUrl from './orderHistoryDetail/OrderHistoryDetailTrackingUrl';

const orderHistoryDetailProducts = document.getElementById(
	'orderHistoryDetailProducts',
);
if (orderHistoryDetailProducts) {
	new OrderHistoryDetailTrackingUrl(orderHistoryDetailProducts);
}
